export const state = {
  surveys: [],
  isLoading: false,
  totalRecords: 0,
  surveyPerPage: 10000,
  activePage: 1
}
